export default "__VITE_PUBLIC_ASSET__fa4a94da__"